import React, { useState } from "react";
import styles from "./Login.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../Redux/store";
import { isEmail, isLength } from "validator";
import { loginUser } from "../../../Redux/Auth/AuthActions";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import InlineLoader from "../../../Components/InlineLoader/InlineLoader";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { loading } = useSelector((state: RootState) => state.auth);

  const loginHandler = (e: React.MouseEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (!loading) {
      if (isEmail(email) && isLength(password, { min: 8 })) {
        dispatch(loginUser({ email, password }, navigate));
      } else {
        if (!isEmail(email)) {
          toast.error("Invalid Email");
        } else if (!isLength(password, { min: 8 })) {
          toast.error("Password must be of minimum 8 characters");
        }
      }
    }
  };
  return (
    <div className={styles.mainContainer}>
      <div className={styles.loginContainer}>
        <form className={styles.formContainer}>
          <div className={styles.headingContainer}>
            <h1 className={styles.heading}>Login</h1>
          </div>
          <div className={styles.inputContainer}>
            <input
              className={styles.input}
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
            />
          </div>
          <div className={styles.inputContainer}>
            <input
              className={styles.input}
              type="text"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
            />
          </div>
          {loading && (
            <div className={styles.loadingContainer}>
              <InlineLoader color="#000000" />
            </div>
          )}
          <div className={styles.buttonContainer}>
            <input
              className={styles.button}
              type="button"
              value="Submit"
              onClick={loginHandler}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
